var _defs, _g, _rect, _path, _path2, _line, _line2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvWithoutCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EV",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #62797e;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #62797e;\n      }\n\n      .cls-5 {\n        fill: #00dc92;\n      }\n\n      .cls-5, .cls-6, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke: #324e55;\n        stroke-width: 2px;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "18.2 88 24.9 88 64.4 88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.9,12h21c4.1,0,7.4,4.1,7.4,9.1v66.9H23.5V21.1c0-5,3.3-9.1,7.4-9.1h0Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 28,
    y: 18.5,
    width: 26.7,
    height: 22.8,
    rx: 3.6,
    ry: 3.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.8,28v38.7c0,1.6-1.3,2.9-2.9,2.9h-1.4c-1.6,0-2.9-1.3-2.9-2.9v-21.7c0-1.6-1.3-2.8-2.8-2.8h-5.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.1,18.7h9.5s.2,9.3-4.7,9.3-4.7-9.3-4.7-9.3Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 73.8,
    y1: 13.2,
    x2: 73.8,
    y2: 16.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80,
    y1: 13.2,
    x2: 80,
    y2: 16.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.3,49.5l-10.5,15.9c-.1.2,0,.5.2.5l10.1-1c.2,0,.3.2.3.3l-4.1,12.6c0,.3.3.4.5.2l13.9-18.6c.1-.2,0-.5-.2-.5l-11,1.7c-.2,0-.3-.2-.3-.3l1.5-10.6c0-.3-.3-.4-.5-.2h0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvWithoutCar);
export default __webpack_public_path__ + "static/media/evWithoutCar.cb892a976bc893db193fe59dec412e4a.svg";
export { ForwardRef as ReactComponent };